// Poster URLs resolve through `workspaceApiBase()` so dev / staging /
// prod surfaces all see the file from the tier they're actually browsing
// — previously hardcoded `https://api.symbols.app/...` sent dev users
// to a frozen prod build that may not even host these files anymore.
import { workspaceApiBase } from '../functions/workspaceApiBase.js'

export const LibrariesInLearn = {
  // FA204 / frank trap — publicFile used to be a bare module-scope const read
  // from inside the `children` factory; it reads as undefined once this
  // component is frank.toJSON'd for platform delivery (workspace d6ea1142,
  // project_frank_drops_module_local_helpers). Moved into `scope`, called via
  // `el.scope.publicFile`.
  scope: {
    publicFile: (id) => `${workspaceApiBase()}/core/files/public/${id}/download`
  },
  flow: 'y',
  state: {
    limit: 5
  },
  tag: 'form',
  align: 'start',
  gap: 'A',
  position: 'relative',
  onSubmit: (ev, el, s) => {
    ev.preventDefault()
    el.call('createItem', s.type, s.key)
  },
  CaptionTitle: {
    Text: {
      text: '{{ learn.libraries.title | polyglot }}'
    }
  },
  Flex: {
    flow: 'y',
    gap: 'A',
    margin: '- - - -X',
    childExtends: 'LibraryItemInLearn',
    childrenAs: 'state',
    children: (el, s) =>
      [
        {
          poster: el.scope.publicFile('68b667ce424350c909ec03f9'),
          projectPath: 'nikoloza/default',
          amount: 206,
          title: 'Default'
        },
        {
          poster: el.scope.publicFile('68b667c8424350c909ec03d4'),
          projectPath: 'nikoloza/ecommerce',
          amount: 271,
          title: 'Ecommerce'
        },
        {
          poster: el.scope.publicFile('68b667ac424350c909ec034e'),
          projectPath: 'nikoloza/forms',
          amount: 248,
          title: 'Forms'
        },
        {
          poster: el.scope.publicFile('68b667c2424350c909ec03a6'),
          projectPath: 'nikoloza/ai',
          amount: 213,
          title: 'AI'
        },
        {
          poster: el.scope.publicFile('68b667d6424350c909ec0421'),
          projectPath: 'nikoloza/web3',
          amount: 85,
          title: 'Web3'
        },
        {
          poster: el.scope.publicFile('68b667db424350c909ec044f'),
          projectPath: 'nikoloza/content-and-marketing',
          amount: 275,
          title: 'Content & Marketing'
        },
        {
          poster: el.scope.publicFile('68b66c9b424350c909ec1f66'),
          projectPath: 'nikoloza/docs',
          amount: 598,
          title: 'Docs'
        },
        {
          poster: el.scope.publicFile('68b671ef424350c909ec5342'),
          projectPath: 'nikoloza/charts',
          amount: 0,
          title: 'Charts'
        },
        {
          poster: el.scope.publicFile('68b66bfb424350c909ec1eb4'),
          projectPath: 'nikoloza/ui',
          amount: 0,
          title: 'No-code'
        },
        {
          poster: el.scope.publicFile('68b672ad424350c909ec544b'),
          projectPath: 'nikoloza/cms',
          amount: 0,
          title: 'CMS'
        },
        {
          poster: el.scope.publicFile('68b66c19424350c909ec1f0c'),
          projectPath: 'nikoloza/code',
          amount: 0,
          title: 'Code'
        },
        {
          poster: el.scope.publicFile('68b63fae424350c909ea336e'),
          projectPath: 'nikoloza/miscellaneous',
          amount: 0,
          title: 'Miscellaneous'
        }
      ].slice(0, s.limit || 30)
  },
  InsertSectionShadow: {
    left: '-C1',
    right: '-C1',
    bottom: 'C'
  },
  Button: {
    extends: ['CanvasButton', 'Button'],
    zIndex: 2,
    margin: '- - - -Y2',
    icon: (el, s) => 'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
    text: (el, s) =>
      el.call('polyglot', s.limit === 5 ? 'learn.libraries.more' : 'learn.libraries.less'),
    gap: 'Y1',
    padding: 'Y2 Z2',
    color: 'caption',
    fontSize: 'Z2',
    Icon: {
      order: 2
    },
    onClick: (ev, el, s) => {
      s.update({
        limit: s.limit === 5 ? 30 : 5
      })
    }
  }
}
